export default (src: string, type: 'audio' | 'video'): Promise<number> =>
  new Promise(resolve => {
    const media = document.createElement(type);
    media.src = src;
    media.onloadeddata = (e: any) => resolve(e.target.duration * 1000);
  });
